import { VxeLayoutFooter } from 'vxe-pc-ui';
export default {
  name: 'XLayoutFooter',
  components: {
    VxeLayoutFooter
  }
};